/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Param_UnknownInputs */

const vi_error_zns_param_unknown = /** @type {(inputs: Error_Zns_Param_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham số này không có trong mẫu — bỏ map tham số này.`)
};

/**

* @param {Error_Zns_Param_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_param_unknown = /** @type {((inputs?: Error_Zns_Param_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Param_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_param_unknown(inputs)
});